import {BackGround} from "../../components/background/background";
import React, {useEffect, useState} from "react";
import Badges from "../../components/badges/badges";
import UploadContentBlock from "../../components/upload_content/upload_content_block";
import {useDetectionState} from "../../core/state/detection/detection_context";
import axios from "axios";
import {socket} from "../../config/client_socket/client_socket";
import {downloading, processing} from "../../core/state/detection/detection_actions";

export const INIT = 'INIT'
export const UPLOADING = 'UPLOADING'
export const PROCESSING = 'PROCESSING'
export const DOWNLOADING = 'DOWNLOADING'
export const COMPLETED = 'COMPLETED'


export function DetectionPage() {
    const {state} = useDetectionState();

    const getState = (state) => {
        switch (state.status) {
            case UPLOADING:
                return <UploadingComponent/>
            case PROCESSING:
                return <ProcessingComponent/>
            case DOWNLOADING:
                return <DownloadingComponent result={state.result}/>
            case INIT:
            default:
                return <UploadContentBlock/>
        }
    }

    return (
        <BackGround>
            <div className={"h-full w-full flex justify-center items-center"}>
                {getState(state)}
            </div>
        </BackGround>
    );
}

function UploadingComponent() {
    const {state, dispatch} = useDetectionState();
    const [percent, setPercent] = useState(0)
    const [file, setFile] = useState({data: null, name: '', type: "Video"});

    useEffect(() => {

        socket.on('message', (data) => {
            console.log(data)
            if (data["status"] === "STARTED") {
                dispatch(processing())
            }
        })

        const submitVideoFile = (data) => {
            let formData = new FormData();
            formData.append("video", data);

            const options = {
                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setPercent(percent);
                    console.log(`${loaded}kb of ${total}kb | ${percent} %`)
                }
            }

            axios.post("api/v1/video", formData, options)
                .then(response => console.log(response))
                .then(result => console.log(result))
                .catch(error => console.log('error', error));
        };

        const submitImageFile = (data) => {
            let formData = new FormData();
            formData.append("image", data);

            const options = {
                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setPercent(percent);
                    console.log(`${loaded}kb of ${total}kb | ${percent} %`)
                }
            }

            axios.post("api/v1/image", formData, options)
                .then(response => console.log(response))
                .then(result => console.log(result))
                .catch(error => console.log('error', error));
        };

        console.log(file.data)
        if (file.data !== null) {
            file.type === "Video" ? submitVideoFile(file.data) : submitImageFile(file.data);
        }

        return () => {
            socket.off('message')
        }
    }, [dispatch, file.data, file.type])

    useEffect(() => {
        if (state.file !== null) {
            let reader = new FileReader();
            reader.readAsDataURL(state.file)
            let x = state.file.name.endsWith("mp4") ? "Video" : "Image";
            reader.onload = ev => setFile({data: ev.target.result, name: state.file.name, type: x});
        }
    }, [state.file]);

    return (
        <div className={"relative w-full h-full flex justify-center items-center"}>
            <video id={"uploaded_video"} className={"absolute"} src={state.src} autoPlay={true} muted={true}
                   loop={true}/>
            <div className={"absolute w-full flex justify-center"}>
                <Badges color={"c_purple"} text={`Uploading ${file.name} ${percent}%...`}/>
            </div>
        </div>
    );
}

function ProcessingComponent() {
    const [result, setResult] = useState({frameNo: null, label: null})
    const {state, dispatch} = useDetectionState();

    useEffect(
        () => {
            socket.on('message', (data) => {
                console.log(data)
                if (data["status"] === "COMPLETED") {
                    dispatch(downloading(data["url"]))
                }
            })

            socket.on('processed_frame', (data) => {
                console.log('processed_frame')
                console.log(data)
                setResult({frameNo: data.frameNo, label: data.label})
            })

            return () => {
                socket.off('processed_image')
                socket.off('message')
            }
        }, [dispatch, setResult]
    )

    const getBadge = () => {
        if (result.label !== null) {
            return <Badges color={result.label === 'Real' ? "c_green" : "c_red"}
                           text={`Processed frame ${result.frameNo}: ${result.label}`}/>
        } else {
            return <Badges color={"c_purple"} text={`Processing...`}/>
        }
    }


    return (
        <div className={"relative w-full h-full flex justify-center items-center"}>
            <video id={"uploaded_video"} className={"absolute"} src={state.src} autoPlay={true} muted={true}
                   loop={true}/>
            <div className={"absolute w-full flex justify-center"}>
                {getBadge()}
            </div>
        </div>
    );
}

function DownloadingComponent({result}) {
    return (
        <div className={"w-full h-full flex justify-center items-center"}>
            <video id={"uploaded_video"} className={"absolute"} src={result} autoPlay={true} muted={true}
                   loop={true}/>
        </div>
    );
}